import { Users, IndianRupee, Clock, Sparkles, Shield, ThumbsUp } from 'lucide-react';

const features = [
  {
    icon: Users,
    title: 'Local Experienced Drivers',
    description: 'Our drivers know every route in Kannur district.',
  },
  {
    icon: IndianRupee,
    title: 'Affordable Pricing',
    description: 'No hidden charges. Transparent and competitive rates.',
  },
  {
    icon: Clock,
    title: 'On-time Pickup',
    description: 'We value your time. Always punctual, always reliable.',
  },
  {
    icon: Sparkles,
    title: 'Clean Vehicles',
    description: 'All our vehicles are regularly cleaned and maintained.',
  },
  {
    icon: Shield,
    title: 'Safe Family Rides',
    description: 'Safety is our priority. Verified drivers and insured vehicles.',
  },
  {
    icon: ThumbsUp,
    title: 'Customer First',
    description: 'Your satisfaction is our success. 24/7 support available.',
  },
];

const WhyChooseUsSection = () => {
  return (
    <section className="py-8 section-gradient-light">
      <div className="container px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <span className="inline-block text-xs sm:text-sm font-bold text-primary uppercase tracking-widest mb-3 animate-fade-up">
            WHY US
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 animate-fade-up stagger-1">
            Why Choose <span className="gradient-text-animated">Friends On Road Cab?</span>
          </h2>
          <p className="text-gray-600 text-base sm:text-lg max-w-2xl mx-auto animate-fade-up stagger-2">
            Trusted by hundreds of families in Kannur, Kerala
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 max-w-7xl mx-auto">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="bg-white rounded-2xl p-6 sm:p-8 border border-gray-100 shadow-lg shadow-black/30 hover:border-primary/50 transition-all duration-500 hover:shadow-xl hover:shadow-primary/10 animate-fade-up group card-shine"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="flex items-center gap-4 mb-4">
                  {/* Icon */} {/* Optimized size for webapp view */}
                  <div className="blue-icon-circle !w-12 !h-12 icon-hover group-hover:animate-glow-pulse shrink-0">
                    <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-white" strokeWidth={2} />
                  </div>

                  {/* Content */}
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 group-hover:text-primary transition-colors duration-300">
                    {feature.title}
                  </h3>
                </div>

                <p className="text-gray-600 leading-relaxed text-sm sm:text-base pl-0 sm:pl-16">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
